// TrainingAlert.jsx
import React, { useState, useCallback } from "react";
import {
  Box,
  Stack,
  Typography,
  IconButton,
  Button,
  Link,
} from "@mui/material";
import SchoolIcon from "@mui/icons-material/School";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import PageButtonBlue from "./PageButtonBlue";

export default function TrainingAlert({ defaultOpen = true }) {
  const [open, setOpen] = useState(defaultOpen);
  const navigate = useNavigate();

  const goToHelp = useCallback(() => {
    navigate("/ayuda");
  }, [navigate]);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  if (!open) return null;

  return (
    <Box
      sx={{
        bgcolor: "#FFB39D",
        borderRadius: 2,
        px: 3,
        py: 2,
        display: "flex",
        alignItems: "center",
        position: "relative",
        mb: 2,
        gap: 3,
      }}
    >
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"    
        sx={{ flexGrow: 1 }}
      >
        <SchoolIcon sx={{ fontSize: 48}} />

        <Box sx={{pl: 1}}>
          <Typography variant="h6" fontWeight={700} sx={{ mb: 0.5 }}>
            Manual y video de capacitación SAGEC
          </Typography>

          <Typography variant="body2">
            Ya están disponibles el manual para descarga y el video de
            capacitación en la sección de{" "}
            <Link
              component="button"
              type="button"
              sx={{ fontWeight: 600, textDecoration: "underline", pb: "3px" }}
              onClick={goToHelp}
            >
              Ayuda y Soporte
            </Link>
            .
          </Typography>
        </Box>
      </Stack>


      <PageButtonBlue
        onClick={goToHelp}
        sx={{
          whiteSpace: "nowrap",
          borderRadius: 50,
          px: 2.5,
          py: 0.5,
          borderColor: "#333",
          color: "#333",
          "&:hover": {
            borderColor: "#000",
            bgcolor: "rgba(0,0,0,0.04)",
          },
        }}
      >
        Entra a capacitación
      </PageButtonBlue>


      <IconButton
        size="small"
        onClick={handleClose}
        sx={{
          position: "absolute",
          top: 4,
          right: 4,
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}
